module.exports = __webpack_public_path__ + "img/aihc.55254901.png";